// Analytics + Pixel snippets (Google Analytics 4, Meta Pixel, Search Console verification)
// All IDs come from env. If they're mock/placeholder, snippets still inject but won't track.

export function injectAnalytics() {
  const GA = process.env.REACT_APP_GA_MEASUREMENT_ID;
  const PIXEL = process.env.REACT_APP_META_PIXEL_ID;
  const GSC = process.env.REACT_APP_GSC_VERIFICATION;
  const isPlaceholder = (v) => !v || /^(G-MOCK|0{6,}|mock-)/i.test(v);

  if (GA && !isPlaceholder(GA) && !document.getElementById("ga-tag")) {
    // GA is validated against a strict placeholder regex above; still, prefer textContent
    // over innerHTML so no attribute parsing / HTML sanitisation is required.
    const encodedGA = encodeURIComponent(GA);
    const s1 = document.createElement("script");
    s1.id = "ga-tag";
    s1.async = true;
    s1.src = `https://www.googletagmanager.com/gtag/js?id=${encodedGA}`;
    document.head.appendChild(s1);
    const s2 = document.createElement("script");
    s2.textContent =
      "window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', " +
      JSON.stringify(GA) +
      ");";
    document.head.appendChild(s2);
  }

  if (PIXEL && !isPlaceholder(PIXEL) && !window.fbq) {
    /* eslint-disable */
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
    document,'script','https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', PIXEL);
    window.fbq('track', 'PageView');
    /* eslint-enable */
  }

  if (GSC && !isPlaceholder(GSC) && !document.querySelector('meta[name="google-site-verification"]')) {
    const meta = document.createElement("meta");
    meta.name = "google-site-verification";
    meta.content = GSC;
    document.head.appendChild(meta);
  }
}

export function trackEvent(name, params = {}) {
  if (window.gtag) window.gtag("event", name, params);
  if (window.fbq) window.fbq("track", name, params);
}
